export enum SlideType {
    LOBBY = 'lobby',
    REGISTRATION = 'registration',
}
